// src/analytics/useAnalytics.ts
import { useContext } from 'react';
import { AnalyticsContext, type AnalyticsContextValue } from './AnalyticsContext';

/**
 * Hook to access analytics tracking functions.
 * Must be used within an AnalyticsProvider.
 * 
 * @returns The analytics context value with track function and initialization status
 * @throws Error if used outside of AnalyticsProvider
 */
export function useAnalytics(): AnalyticsContextValue {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
}
